import React, { useState } from "react";
import { Input, Button, message } from "antd";
import { MailOutlined, ArrowLeftOutlined, KeyOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const FP_STYLES = `
	.fp-wrapper {
		min-height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		background: linear-gradient(120deg, #0B1220 0%, #16213E 45%, #7C3A0F 100%);
		background-size: 200% 200%;
		animation: fpGradientShift 12s ease infinite;
		padding: 20px;
	}

	.fp-card {
		width: 100%;
		max-width: 380px;
		background: #fff;
		border-radius: 18px;
		padding: 32px 28px;
		box-shadow: 0 20px 50px rgba(0,0,0,0.35);
		position: relative;
		animation: fpFadeInUp 0.45s ease both;
	}

	.fp-back {
		position: absolute;
		top: 18px;
		left: 18px;
		width: 32px;
		height: 32px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #F4F6F9;
		color: #595959;
		cursor: pointer;
		transition: background 0.2s ease;
	}
	.fp-back:hover {
		background: #E4E8EE;
	}

	.fp-icon-badge {
		width: 60px;
		height: 60px;
		border-radius: 50%;
		margin: 8px auto 18px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: linear-gradient(135deg, #F59E0B, #D97706);
		color: #fff;
		font-size: 24px;
		box-shadow: 0 8px 20px rgba(217,119,6,0.35);
	}

	.fp-title {
		text-align: center;
		font-size: 19px;
		font-weight: 700;
		color: #16213E;
		margin: 0;
	}
	.fp-subtitle {
		text-align: center;
		font-size: 13px;
		color: #8A94A3;
		margin-top: 6px;
		margin-bottom: 24px;
		line-height: 1.5;
	}

	.fp-label {
		font-size: 12px;
		color: #8c8c8c;
		margin-bottom: 4px;
	}

	.fp-gradient-btn {
		background: linear-gradient(135deg, #F59E0B, #D97706) !important;
		border: none !important;
		box-shadow: 0 4px 14px rgba(217,119,6,0.35);
		height: 40px;
		font-weight: 600;
	}
	.fp-gradient-btn:hover {
		transform: translateY(-1px);
	}

	.fp-success {
		text-align: center;
		padding: 8px 0 4px;
	}
	.fp-success-icon {
		width: 60px;
		height: 60px;
		border-radius: 50%;
		margin: 0 auto 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #ECFDF5;
		color: #059669;
		font-size: 26px;
	}

	@keyframes fpGradientShift {
		0% { background-position: 0% 50%; }
		50% { background-position: 100% 50%; }
		100% { background-position: 0% 50%; }
	}
	@keyframes fpFadeInUp {
		from { opacity: 0; transform: translateY(12px); }
		to { opacity: 1; transform: translateY(0); }
	}
`;

const ForgotPasswordPage = () => {
	const navigate = useNavigate();
	const [email, setEmail] = useState("");
	const [sending, setSending] = useState(false);
	const [sent, setSent] = useState(false);

	const isValidEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);

	const handleSubmit = async () => {
		if (!email.trim()) {
			return message.warning("Please enter your registered email address");
		}
		if (!isValidEmail(email.trim())) {
			return message.warning("Please enter a valid email address");
		}

		setSending(true);
		try {
		
			await new Promise((res) => setTimeout(res, 700));
			setSent(true);
		} catch {
			message.error("Something went wrong. Please try again.");
		} finally {
			setSending(false);
		}
	};

	return (
		<div className="fp-wrapper">
			<style>{FP_STYLES}</style>

			<div className="fp-card">
				<div className="fp-back" onClick={() => navigate(-1)}>
					<ArrowLeftOutlined style={{ fontSize: 14 }} />
				</div>

				{!sent ? (
					<>
						<div className="fp-icon-badge">
							<KeyOutlined />
						</div>
						<h3 className="fp-title">Forgot Password?</h3>
						<p className="fp-subtitle">
							Enter your registered email address and we'll send you a link to
							reset your password.
						</p>

						<div style={{ marginBottom: 20 }}>
							<div className="fp-label">Email Address</div>
							<Input
								size="large"
								prefix={<MailOutlined style={{ color: "#bfbfbf" }} />}
								placeholder="you@example.com"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								onPressEnter={handleSubmit}
								autoFocus
							/>
						</div>

						<Button
							block
							className="fp-gradient-btn"
							style={{ color: "#fff" }}
							loading={sending}
							onClick={handleSubmit}
						>
							Send Reset Link
						</Button>
					</>
				) : (
					<div className="fp-success">
						<div className="fp-success-icon">
							<MailOutlined />
						</div>
						<h3 className="fp-title">Check your email</h3>
						<p className="fp-subtitle">
							If an account exists for <strong>{email}</strong>, you'll receive
							a password reset link shortly.
						</p>
						<Button block onClick={() => navigate(-1)}>
							Back to Login
						</Button>
					</div>
				)}
			</div>
		</div>
	);
};

export default ForgotPasswordPage;